export function formatRoundPrice(price: number) {
    return price % 1 === 0 ? `${Number(price).toFixed(0)},-` : price;
}
